import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PointService {
  public code: string;
  constructor() { }
}
